import React from 'react';
import { ConfirmationContainer } from './styles';

export default () => {
  return <ConfirmationContainer>Please wait...</ConfirmationContainer>;
};
